<template>
   <div>
    <div class="backtop-wrap-box-ranking222" style=" bottom: 287px;">
        <a class="process-wrap222" href="https://work.weixin.qq.com/kfid/kfcefe337aa26b7921b" target="_blank">
            <div>联系客服</div>
        </a>
    </div>

    <div class="backtop-wrap-box-ranking-txc" style=" bottom: 212px;">
        <a class="process-wrap-txc" href="https://txc.qq.com/products/619573#label=default" target="_blank">
            <div>需求反馈</div>
        </a>
    </div>
   </div>

    <!-- <div class="header-float">
        <a href="https://work.weixin.qq.com/kfid/kfcefe337aa26b7921b"   target="_blank" class="backtop-wrap-box_new">
        </a>
    </div> -->
</template>

<script>
export default {
    data(){
        return {
            isshow:false
        }
    }
}
</script>

<style type="text/less" lang="less" scoped>

.backtop-wrap-box-ranking222 {
    position: fixed;
    right: 10px;
    bottom: 362px;
    z-index: 5555;
    background: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.08);
    border-radius: 8px;   

 .process-wrap222 {
        position: relative;
        width: 65px;
        height: 70px;
        background: url("../../assets/image/img_ls.png") no-repeat center 15px;
        line-height: 70px;
        padding-top: 15px;
        padding-bottom: 15px;
        color: #0c7df5;
        font-family: "微软雅黑";
        text-align: center;
        font-size: 13px;
        display: inline-block;
        text-decoration: none;        

        &:hover,
        &.active {
            background: url("../../assets/image/img_bs.png") #0c7df5 no-repeat center 15px;
            display: block;
            border-radius: 8px;
            box-shadow: 2px 3.46px 12px 4px rgba(11,125,245,0.50);
            color: #fff;

            > .content {
                display: block;
            }
        }
    }
}

.backtop-wrap-box-ranking-txc {
    position: fixed;
    right: 10px;
    bottom: 213px;
    z-index: 5555;
    background: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.08);
    border-radius: 8px;

    .process-wrap-txc {
        position: relative;
        width: 65px;
        height: 70px;
        background: url("../../assets/image/txc.png") no-repeat center 15px;
        line-height: 70px;
        padding-top: 15px;
        padding-bottom: 15px;
        color: #0c7df5;
        font-family: "微软雅黑";
        text-align: center;
        font-size: 13px;
        display: inline-block;
        text-decoration: none;       

        &:hover,
        &.active {
            background: url("../../assets/image/txc_bs.png") #0c7df5 no-repeat center 15px;
            display: block;
            border-radius: 8px;
            box-shadow: 2px 3.46px 12px 4px rgba(11,125,245,0.50);
            color: #fff;

            > .content {
                display: block;
            }
        }
    }
}

    .kf{
        position: fixed;
        z-index: 5;
        right: 0px;
        top: calc(50% - 150px);
        background-color: white;
        padding: 3px;
        text-align: center;
        font-size: 13px;
        border: 1px solid #bbbcbd;
    }
    .img{
        width: 120px;
        height: 120px;
    }
    .header-float{
        z-index: 999;
        position: fixed;
        //top: calc(50% - 100px);
        bottom:7vw;
        right: 10px;
        color: #fff;
        width: 142px;
        height:66px;
        font-size: 12px;
        text-decoration: none;
        line-height: 14px;
    }
    .link{
        text-align: center;
        display: block;
        padding: 10px 5px;
        color: #fff;
        position: relative;
    }
    .pop{
        position: absolute;
        z-index: 100;
        display: block;
        top: -10px;
        left: 32px;
        border: 1px solid #ccc;
        
    }
    .backtop-wrap-box_new {
          position: fixed;
          right: 10px;
          bottom: 40px;
          z-index: 5555;
          background: url("../../assets/image/weixin.png") no-repeat;
          width:142px;
          height:66px;
}
 .backtop-wrap-box_new:hover {
      position: fixed;
      right: 10px;
      bottom: 40px;
      z-index: 5555;
      width:142px;
      height:66px;
      background: url("../../assets/image/weixin_hover.png") center center no-repeat;
}
</style>